import TagManager from 'react-gtm-module';
export const checklistDataLayer = (event, page, checklist, step) => {
    TagManager.dataLayer({ dataLayer: { event, page, checklist, step } });
};
